import type { AppBootstrapStatus } from '@/providers/AppBootstrapProvider.context';

export interface AppBootstrapSnapshot {
    status: AppBootstrapStatus;
    isAuthenticated: boolean;
    organizationsCount: number | null;
}

let currentSnapshot: AppBootstrapSnapshot | null = null;

export function getAppBootstrapSnapshot(): AppBootstrapSnapshot | null {
    return currentSnapshot;
}

export function setAppBootstrapSnapshot(snapshot: AppBootstrapSnapshot) {
    currentSnapshot = snapshot;
}

export function resetAppBootstrapSnapshot() {
    currentSnapshot = null;
}
